export default "/images/vendor/flag-icon-css/flags/1x1/ru.svg?f760036294e1fff52a9a88663d0d7a46";